import { render } from "./PaginationArrowLeft.vue?vue&type=template&id=4540b498"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PaginationArrowLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4540b498"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4540b498', __exports__)) {
    api.reload('4540b498', __exports__)
  }
  
  module.hot.accept("./PaginationArrowLeft.vue?vue&type=template&id=4540b498", () => {
    api.rerender('4540b498', render)
  })

}


export default __exports__